

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue'
import router from './router/index.js'
import i18n from "./i18n.js";
import api from '@/api';
// import "@/mock";
import './assets/main.css'

import 'element-plus/dist/index.css'

import ElementPlus from "element-plus";
import enLocale from 'element-plus/es/locale/lang/en';
import 'element-plus/theme-chalk/el-dropdown.css';
import 'element-plus/theme-chalk/el-avatar.css';
import 'element-plus/theme-chalk/el-icon.css';
// import "element-plus/dist/index.css";
import './css/base.scss'
import './css/font/iconfont.css'
import './components/sakura/src/sakura-tabs/index.scss';
// @ts-ignore
import { registerSakura } from "./js/sakura.js";
import VueVirtualScroller from "vue-virtual-scroller";

// @ts-ignore
import sakura from './components/sakura/index.js';
import MaterialInput from "./components/material-input.vue"; // Make sure the path is correct
// @ts-ignore
import eventBus from './eventBus.js';

// import drag from '@/js/directive'
// @ts-ignore
import components from "./../src/js/component.js";
import { RecycleScroller } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

const app = createApp(App);
const pinia = createPinia();

components.forEach(({ name, component }) => {
    app.component(name, component);
});
app.use(pinia); // Store management
app.use(router);
app.use(i18n); // Attach i18n globally
app.use(ElementPlus, {
    locale: enLocale, // Set English as the default language
  });
app.use(sakura);
app.use(VueVirtualScroller);
registerSakura(app);
app.component("MaterialInput", MaterialInput);
app.component("RecycleScroller", RecycleScroller);
app.provide("eventBus", eventBus);

// ✅ Set $t globally on Vue instance
app.config.globalProperties.$t = i18n.global.t;
// Create a global function to always return objects
// Force $t to return objects when needed
// window.$t = (key: string, params?: any) => {
//     const translation = i18n.global.t(key, params);
    
//     // If the result is still a key, return an object (fallback)
//     // @ts-ignore
//     return typeof translation === "string" && translation === key ? i18n.global.getLocaleMessage(i18n.global.locale)[key] : translation;
//   };

app.config.globalProperties.$api = api; // Attach API globally
// app.config.globalProperties.$sakura = sakura;

// ✅ Set $t globally on window
window.$t = i18n.global.t;

// app.directive('drag', drag)

app.mount('#app')
